export default "__VITE_ASSET__4Fh8VZQA__"